'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @flow
var howItWorks = exports.howItWorks = {
  title: 'How does it work?',
  description: 'A platform to learn all you need through video courses',
  learn_title: 'Learn',
  learn_description: 'Find what you need among 100,000 courses of all levels and topics. Learn at your own pace and together with thousands of fellow students that will help you.',
  teach_title: 'Teach',
  teach_description: 'Show your skills and create a course. Record it, upload it and start making money, it is that easy. There are millions of people wanting to learn. Are you ready to teach them?',
  promote_title: 'Promote',
  promote_description: 'You can also make money by promoting courses created by others. Become an Affiliate and use social networks, webs and offline channels.',
  tech_title: 'We combine our product and technology in a platform designed for you',
  tech_description: 'You can also make money promoting the courses of other people. Become an Affiliate and use social networks, webs and offline channels.',
  tech_products_title: 'A variety of products made to fit your needs',
  tech_products_description: 'Find out what fits your style: courses, subscriptions or degrees. It is up to you.',
  tech_multiple_title: 'Many services to help you learn',
  tech_multiple_description: 'Notebooks, Notes, Questions, Projects, Groups, Tutors... whatever you need to improve your experience.',
  tech_cta: 'Register now, it is free'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/en/how_it_work.js
// module id = 717
// module chunks = 0